var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 20,
    viewBox: "0 0 7 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38649 0.375H4.61351V3.96478C4.61351 4.99951 4.91996 5.96052 5.52432 6.83953L5.52423 6.8396L5.52978 6.84725L5.84879 7.28707C6.36747 8.04305 6.625 8.88922 6.625 9.76722V19.625H0.375V9.76722C0.375 8.89132 0.631399 8.04338 1.15332 7.25003L1.47022 6.81312L1.47023 6.81312L1.47136 6.81154C2.08148 5.96113 2.38649 4.96271 2.38649 3.96478V0.375Z",
    fill: "#78264F",
    stroke: "#78264F",
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.65086abd.svg";
export { ForwardRef as ReactComponent };